import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-15">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-16">
        <span className="font-sans font-bold text-lg text-gray-900 group-hover:text-brand-600 transition-colors" data-id="element-17">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-18" />
      </button>
      <AnimatePresence data-id="element-19">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-20">
            <div className="pb-6 font-serif text-gray-700 leading-relaxed" data-id="element-21">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}